import apiAuditTrails from "../api/AuditTrailsAPI";

const search = async (params) => {
    try {
        const result = await apiAuditTrails.search(params)
        if (result) {
            return result
        } else return []

    } catch (err) {
        throw err
    }
}

const save = async (params) => {
    try {
        const result = await apiAuditTrails.save(params)
        if (result) {
            return result
        } else return []

    } catch (err) {
        throw err
    }
}

const getUserRoleList = async () => {
    try {
        const result = await apiAuditTrails.getUserRoleList()
        if (result) {
            return result
        } else return []

    } catch (err) {
        throw err
    }
}

export default {
    search: search,
    save: save,
    getUserRoleList: getUserRoleList
}